/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { formatArticleError, pluralize } from '@utils';
import { useVideo } from '@api/hooks';

const Item = ({ module, previewImg, errors }) => {
  const { video, error } = useVideo({ id: module?.content?.videoId });

  let description = pluralize(video?.id ? 1 : 0, 'video');

  if (module.content.videoId) {
    description = error ? formatArticleError(error) : video.title || 'loading video...';
  }

  return (
    <InfoItem.WithError error={errors} size="large" image={previewImg} description={description}>
      Hero Video
    </InfoItem.WithError>
  );
};

export default Item;
